module.exports = __webpack_public_path__ + "img/upload.1c55083b.svg";